// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1KM9h","row":"ProcedureTreatmentSummary_row__2hnFU"};